export default "__VITE_ASSET__DwzvwuSK__"